//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import lbsManager from "@/Manager/03.Sys/LbsManager";

import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmScale from "vue-baidu-map/components/controls/Scale.vue";
import BmNavigation from "vue-baidu-map/components/controls/Navigation";
import BmMarker from "vue-baidu-map/components/overlays/Marker";
import BmLabel from "vue-baidu-map/components/overlays/Label";
import BmPolyline from "vue-baidu-map/components/overlays/Polyline";

export default {
  components: {
    "baidu-map": BaiduMap,
    "bm-scale": BmScale,
    "bm-navigation": BmNavigation,
    "bm-marker": BmMarker,
    "bm-label": BmLabel,
    "bm-polyline": BmPolyline
  },
  data() {
    return {

      MapItem:null,
      
      BaiduMapAK: "8QI6NaQGIWgShfHVsG7KAV6t",
      IsMapReady: false,

      CenterGps: {
        lat: 23.10229,
        lng: 113.32456
      },
      markers: [
        // {
        //   position: {
        //     lat: 23.10229,
        //     lng: 113.32456
        //   }
        // },
        // {
        //   position: {
        //     lat: 23.21229,
        //     lng: 113.3247
        //   }
        // }
      ],
      polyline: [
        {
          color: "#1afa29",
          width: 4,
          dottedLine: false,
          points: [
            // {
            //   lat: 23.10229,
            //   lng: 113.32456
            // },
            // {
            //   lat: 23.21229,
            //   lng: 113.32457
            // },
            // {
            //   lat: 23.21229,
            //   lng: 113.3246
            // },
            // {
            //   lat: 23.21229,
            //   lng: 113.3247
            // }
          ]
        }
      ]
    };
  },

  methods: {
    onMapReady({ BMap }) {
      console.log("BMap", BMap);

      this.IsMapReady = true;

      console.log("IsMapReady", this.IsMapReady);
    },

    getIsMapReady() {
      return this.IsMapReady;
    },

    setControlValue(wxMap) {
      console.log("setControlValue==========");
      //if(!IsMapReady) return;

      if(wxMap == null) return;
      this.MapItem = wxMap;

      this.CenterGps.lat = wxMap.latitude;
      this.CenterGps.lng = wxMap.longitude;

      if (wxMap.markers && wxMap.markers.length > 0) {
        var index = 0;
        wxMap.markers.forEach(m => {
          //this.$set(this.markers,index,m);
          var marker={
            position:{
              lat : m.latitude,
              lng : m.longitude,
            },
          };
          this.markers.push(marker);
          index++;
        });
        console.log("this.markers===", this.markers);
      }

      if (wxMap.polyline && wxMap.polyline.length > 0) {
        var index2 = 0;
        wxMap.polyline.forEach(m => {
          //this.$set(this.polyline,index,m);
          if(m.points){
            m.points = m.points.map(p=>{
              return {
                lat : p.latitude,
                lng : p.longitude,
              };
            });
          }
          this.polyline.push(m);
          index2++;
        });
        console.log("this.polyline===", this.polyline);
      }
    }
  },
  created() {
    
  }
};
